/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosRequestConfig } from 'axios';
import { getDTTFlag } from './helper';

const isDev = process.env['NODE_ENV'] === 'development';
const commonHeaders = () => {
  const dtt = getDTTFlag();
  return {
    'Content-Type': 'application/json',
    ...(dtt ? { dtt } : {}),
  };
};
const instance = axios.create({
  headers: commonHeaders(),
  ...(isDev && {
    baseURL: process.env['NEXT_PUBLIC_PROXY_HOST'] || '',
  }),
});

export const axiosWrapper = {
  intercept: (interceptConfigs: Record<string, string | boolean | number>) => {
    if (Object.keys(interceptConfigs)?.length) {
      for (const key in interceptConfigs) {
        instance.defaults.headers.common[key] = interceptConfigs[key] || '';
      }
    }
  },
  get: <T = any>(url: string, config?: AxiosRequestConfig) => {
    const customHeaders = {
      ...instance.defaults.headers.get,
      ...commonHeaders(),
      ...config?.headers,
    };

    return instance.get<T>(url, { ...config, headers: customHeaders });
  },
  post(url: string, data?: any, config?: AxiosRequestConfig) {
    const customHeaders = {
      ...instance.defaults.headers.post,
      ...commonHeaders(),
      ...config?.headers,
    };

    return instance.post(url, data, { ...config, headers: customHeaders });
  },
  put: (url: string, data?: any, config?: AxiosRequestConfig) => {
    const customHeaders = {
      ...instance.defaults.headers.put,
      ...commonHeaders(),
      ...config?.headers,
    };

    return instance.put(url, data, { ...config, headers: customHeaders });
  },
  delete: (url: string, config?: AxiosRequestConfig) => {
    const customHeaders = {
      ...instance.defaults.headers.delete,
      ...commonHeaders(),
      ...config?.headers,
    };

    return instance.delete(url, { ...config, headers: customHeaders });
  },
};
